import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Locacao from "../pages/locacao-equipamentos-industriais/page";
import Servicos from "../pages/servicos/page";
import Equipamentos from "../pages/equipamentos-e-componentes/page";
import Oficina from "../pages/oficina/page";
import Mangueiras from "../pages/mangueiras-hidraulicas/page";
import Bombas from "../pages/bombas-hidraulicas/page";
import Motores from "../pages/motores-hidraulicos/page";
import Cilindros from "../pages/cilindros-hidraulicos/page";
import Valvulas from "../pages/valvulas-hidraulicas/page";
import Manometros from "../pages/manometros-medidores/page";
import ValvulasControle from "../pages/valvulas-de-controle/page";
import TrabalheConosco from "../pages/trabalhe-conosco/page";
import Contato from "../pages/contato/page";
import Acessorios from "../pages/acessorios-conexoes/page";
import Acumuladores from "../pages/acumuladores-hidraulicos/page";
import Cases from "../pages/cases/page";
import CaseDesmontagemPrensaFardos from "../pages/cases/case-desmontagem-prensa-fardos-celulose/page";
import CaseDesmontagemMontagemIdFan from "../pages/cases/case-desmontagem-montagem-ventilador-id-fan-caldeira-recuperacao/page";
import CaseSubstituicaoVariadorIdFan6 from "../pages/cases/case-substituicao-variador-velocidade-id-fan-6-caldeira-recuperacao/page";
import CaseSubstituicaoMolasGncd from "../pages/cases/case-substituicao-molas-antivibracao-ventilador-gncd/page";
import CaseManutencaoTransportadoresFardos from "../pages/cases/case-manutencao-transportadores-fardos-substituicao-correntes/page";
import CaseReparoGruaFlorestal from "../pages/cases/reparo-grua-florestal-patio-madeiras/page";
import CaseMajorRepairRedutorPanelaGusa from "../pages/cases/major-repair-redutor-tampa-panela-gusa/page";
import CaseRecuperacaoCilindroGuindaste from "../pages/cases/recuperacao-cilindro-hidraulico-guindaste/page";
import CaseRecuperacaoBombaVacuo from "../pages/cases/recuperacao-bomba-vacuo-industrial/page";
import CaseFabricacaoCarcacaMotoredutor from "../pages/cases/fabricacao-carcaca-motoredutor-industrial/page";
import CaseRecuperacaoAcumuladoresHidraulicos from "../pages/cases/recuperacao-acumuladores-hidraulicos/page";
import CaseRecuperacaoMotoresPneumaticos from "../pages/cases/recuperacao-motores-pneumaticos-industriais/page";
import CaseEngenhariaConfiabilidadeCilindrosAmarradeira from "../pages/cases/engenharia-confiabilidade-cilindros-amarradeira/page";
import CaseRecuperacaoBombasPistaoHidraulicas from "../pages/cases/recuperacao-bombas-pistao-hidraulicas/page";
import RecuperacaoCilindros from "../pages/recuperacao-cilindros-hidraulicos/page";
import RecuperacaoBombas from "../pages/recuperacao-bombas-hidraulicas/page";
import RecuperacaoMotores from "../pages/recuperacao-motores-hidraulicos/page";
import RecuperacaoRedutores from "../pages/recuperacao-redutores-industriais/page";
import RecuperacaoGruas from "../pages/recuperacao-gruas-e-equipamentos-florestais/page";
import RecuperacaoCelulose from "../pages/recuperacao-equipamentos-papel-celulose/page";
import MecanicaIndustrial from "../pages/mecanica-industrial/page";
import HidraulicaIndustrial from "../pages/hidraulica-industrial/page";
import CaldeirariaSolda from "../pages/caldeiraria-solda/page";
import LubrificacaoIndustrial from "../pages/lubrificacao-industrial/page";
import LocalAracruzCaldeiraria from "../pages/local/aracruz/caldeiraria-solda/page";
import LocalAracruzHidraulica from "../pages/local/aracruz/hidraulica-industrial/page";
import LocalAracruzLubrificacao from "../pages/local/aracruz/lubrificacao-industrial/page";
import LocalAracruzMecanica from "../pages/local/aracruz/mecanica-industrial/page";
import LocalAracruzCilindros from "../pages/local/aracruz/recuperacao-cilindros-hidraulicos/page";
import LocalAracruzBombas from "../pages/local/aracruz/recuperacao-bombas-hidraulicas/page";
import LocalAracruzMotores from "../pages/local/aracruz/recuperacao-motores-hidraulicos/page";
import LocalAracruzRedutores from "../pages/local/aracruz/recuperacao-redutores-industriais/page";
import LocalAracruzGruas from "../pages/local/aracruz/recuperacao-gruas-florestais/page";
import LocalAracruzCelulose from "../pages/local/aracruz/recuperacao-equipamentos-celulose/page";
import LocalSerraCilindros from "../pages/local/serra/recuperacao-cilindros-hidraulicos/page";
import LocalSerraBombas from "../pages/local/serra/recuperacao-bombas-hidraulicas/page";
import LocalSerraMotores from "../pages/local/serra/recuperacao-motores-hidraulicos/page";
import LocalSerraRedutores from "../pages/local/serra/recuperacao-redutores-industriais/page";
import LocalSerraHidraulica from "../pages/local/serra/hidraulica-industrial/page";
import LocalSerraMecanica from "../pages/local/serra/mecanica-industrial/page";
import LocalVitoriaCilindros from "../pages/local/vitoria/recuperacao-cilindros-hidraulicos/page";
import LocalVitoriaBombas from "../pages/local/vitoria/recuperacao-bombas-hidraulicas/page";
import LocalVitoriaMotores from "../pages/local/vitoria/recuperacao-motores-hidraulicos/page";
import LocalVitoriaRedutores from "../pages/local/vitoria/recuperacao-redutores-industriais/page";
import LocalVitoriaHidraulica from "../pages/local/vitoria/hidraulica-industrial/page";
import LocalVitoriaMecanica from "../pages/local/vitoria/mecanica-industrial/page";
import LocalLinharesCilindros from "../pages/local/linhares/recuperacao-cilindros-hidraulicos/page";
import LocalLinharesBombas from "../pages/local/linhares/recuperacao-bombas-hidraulicas/page";
import LocalLinharesMotores from "../pages/local/linhares/recuperacao-motores-hidraulicos/page";
import LocalLinharesRedutores from "../pages/local/linhares/recuperacao-redutores-industriais/page";
import LocalLinharesHidraulica from "../pages/local/linhares/hidraulica-industrial/page";
import LocalLinharesMecanica from "../pages/local/linhares/mecanica-industrial/page";
import { Navigate } from "react-router-dom";
import CaseRecuperacaoCorrecaoEstruturalVentiladorTerciario from "../pages/cases/recuperacao-correcao-estrutural-ventilador-terciario/page";
import CaseSubstituicaoInstalacaoVentiladorSecagemIndustrial from "../pages/cases/case-substituicao-instalacao-ventilador-secagem-industrial/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/servicos-de-campo",
    element: <Servicos />,
  },
  {
    path: "/servicos",
    element: <Navigate to="/servicos-de-campo" replace />,
  },
  {
    path: "/equipamentos-e-componentes",
    element: <Equipamentos />,
  },
  {
    path: "/duraflow",
    element: <Navigate to="/equipamentos-e-componentes" replace />,
  },
  {
    path: "/oficina",
    element: <Oficina />,
  },
  {
    path: "/contato",
    element: <Contato />,
  },
  {
    path: "/cases",
    element: <Cases />,
  },
  {
    path: "/case-desmontagem-prensa-fardos-celulose",
    element: <CaseDesmontagemPrensaFardos />,
  },
  {
    path: "/case-manutencao-ventiladores-industriais-secagem-celulose",
    element: <Navigate to="/cases/substituicao-instalacao-ventilador-secagem-industrial" replace />,
  },
  {
    path: "/case-desmontagem-montagem-ventilador-id-fan-caldeira-recuperacao",
    element: <CaseDesmontagemMontagemIdFan />,
  },
  {
    path: "/case-substituicao-variador-velocidade-id-fan-6-caldeira-recuperacao",
    element: <CaseSubstituicaoVariadorIdFan6 />,
  },
  {
    path: "/case-substituicao-molas-antivibracao-ventilador-gncd",
    element: <CaseSubstituicaoMolasGncd />,
  },
  {
    path: "/case-manutencao-transportadores-fardos-substituicao-correntes",
    element: <CaseManutencaoTransportadoresFardos />,
  },
  {
    path: "/cases/reparo-grua-florestal-patio-madeiras",
    element: <CaseReparoGruaFlorestal />,
  },
  {
    path: "/cases/major-repair-redutor-tampa-panela-gusa",
    element: <CaseMajorRepairRedutorPanelaGusa />,
  },
  {
    path: "/cases/recuperacao-cilindro-hidraulico-guindaste",
    element: <CaseRecuperacaoCilindroGuindaste />,
  },
  {
    path: "/cases/recuperacao-bomba-vacuo-industrial",
    element: <CaseRecuperacaoBombaVacuo />,
  },
  {
    path: "/cases/fabricacao-carcaca-motoredutor-industrial",
    element: <CaseFabricacaoCarcacaMotoredutor />,
  },
  {
    path: "/cases/recuperacao-acumuladores-hidraulicos",
    element: <CaseRecuperacaoAcumuladoresHidraulicos />,
  },
  {
    path: "/cases/recuperacao-motores-pneumaticos-industriais",
    element: <CaseRecuperacaoMotoresPneumaticos />,
  },
  {
    path: "/cases/engenharia-confiabilidade-cilindros-amarradeira",
    element: <CaseEngenhariaConfiabilidadeCilindrosAmarradeira />,
  },
  {
    path: "/cases/recuperacao-bombas-pistao-hidraulicas",
    element: <CaseRecuperacaoBombasPistaoHidraulicas />,
  },
  {
    path: "/cases/substituicao-instalacao-ventilador-secagem-industrial",
    element: <CaseSubstituicaoInstalacaoVentiladorSecagemIndustrial />,
  },
  {
    path: "/cases/recuperacao-correcao-estrutural-ventilador-terciario",
    element: <CaseRecuperacaoCorrecaoEstruturalVentiladorTerciario />,
  },
  {
    path: "/recuperacao-cilindros-hidraulicos",
    element: <RecuperacaoCilindros />,
  },
  {
    path: "/recuperacao-bombas-hidraulicas",
    element: <RecuperacaoBombas />,
  },
  {
    path: "/recuperacao-motores-hidraulicos",
    element: <RecuperacaoMotores />,
  },
  {
    path: "/recuperacao-redutores-industriais",
    element: <RecuperacaoRedutores />,
  },
  {
    path: "/recuperacao-gruas-e-equipamentos-florestais",
    element: <RecuperacaoGruas />,
  },
  {
    path: "/recuperacao-equipamentos-papel-celulose",
    element: <RecuperacaoCelulose />,
  },
  {
    path: "/mecanica-industrial",
    element: <MecanicaIndustrial />,
  },
  {
    path: "/hidraulica-industrial",
    element: <HidraulicaIndustrial />,
  },
  {
    path: "/caldeiraria-solda",
    element: <CaldeirariaSolda />,
  },
  {
    path: "/lubrificacao-industrial",
    element: <LubrificacaoIndustrial />,
  },
  {
    path: "/mangueiras-hidraulicas",
    element: <Mangueiras />,
  },
  {
    path: "/bombas-hidraulicas",
    element: <Bombas />,
  },
  {
    path: "/motores-hidraulicos",
    element: <Motores />,
  },
  {
    path: "/cilindros-hidraulicos",
    element: <Cilindros />,
  },
  {
    path: "/valvulas-hidraulicas",
    element: <Valvulas />,
  },
  {
    path: "/manometros-medidores",
    element: <Manometros />,
  },
  {
    path: "/valvulas-de-controle",
    element: <ValvulasControle />,
  },
  {
    path: "/acessorios-conexoes",
    element: <Acessorios />,
  },
  {
    path: "/acumuladores-hidraulicos",
    element: <Acumuladores />,
  },
  {
    path: "/trabalhe-conosco",
    element: <TrabalheConosco />,
  },
  {
    path: "/locacao-equipamentos-industriais",
    element: <Locacao />,
  },
  {
    path: "/aluguel",
    element: <Navigate to="/locacao-equipamentos-industriais" replace />,
  },
  // SEO Local Aracruz
  {
    path: "/recuperacao-cilindros-hidraulicos-aracruz",
    element: <LocalAracruzCilindros />,
  },
  {
    path: "/recuperacao-bombas-hidraulicas-aracruz",
    element: <LocalAracruzBombas />,
  },
  {
    path: "/recuperacao-motores-hidraulicos-aracruz",
    element: <LocalAracruzMotores />,
  },
  {
    path: "/recuperacao-redutores-industriais-aracruz",
    element: <LocalAracruzRedutores />,
  },
  {
    path: "/recuperacao-gruas-florestais-aracruz",
    element: <LocalAracruzGruas />,
  },
  {
    path: "/recuperacao-equipamentos-celulose-aracruz",
    element: <LocalAracruzCelulose />,
  },
  {
    path: "/mecanica-industrial-aracruz",
    element: <LocalAracruzMecanica />,
  },
  {
    path: "/hidraulica-industrial-aracruz",
    element: <LocalAracruzHidraulica />,
  },
  {
    path: "/caldeiraria-solda-aracruz",
    element: <LocalAracruzCaldeiraria />,
  },
  {
    path: "/lubrificacao-industrial-aracruz",
    element: <LocalAracruzLubrificacao />,
  },
  // SEO Local Serra
  {
    path: "/recuperacao-cilindros-hidraulicos-serra",
    element: <LocalSerraCilindros />,
  },
  {
    path: "/recuperacao-bombas-hidraulicas-serra",
    element: <LocalSerraBombas />,
  },
  {
    path: "/recuperacao-motores-hidraulicos-serra",
    element: <LocalSerraMotores />,
  },
  {
    path: "/recuperacao-redutores-industriais-serra",
    element: <LocalSerraRedutores />,
  },
  {
    path: "/hidraulica-industrial-serra",
    element: <LocalSerraHidraulica />,
  },
  {
    path: "/mecanica-industrial-serra",
    element: <LocalSerraMecanica />,
  },
  // SEO Local Vitória
  {
    path: "/recuperacao-cilindros-hidraulicos-vitoria",
    element: <LocalVitoriaCilindros />,
  },
  {
    path: "/recuperacao-bombas-hidraulicas-vitoria",
    element: <LocalVitoriaBombas />,
  },
  {
    path: "/recuperacao-motores-hidraulicos-vitoria",
    element: <LocalVitoriaMotores />,
  },
  {
    path: "/recuperacao-redutores-industriais-vitoria",
    element: <LocalVitoriaRedutores />,
  },
  {
    path: "/hidraulica-industrial-vitoria",
    element: <LocalVitoriaHidraulica />,
  },
  {
    path: "/mecanica-industrial-vitoria",
    element: <LocalVitoriaMecanica />,
  },
  // SEO Local Linhares
  {
    path: "/recuperacao-cilindros-hidraulicos-linhares",
    element: <LocalLinharesCilindros />,
  },
  {
    path: "/recuperacao-bombas-hidraulicas-linhares",
    element: <LocalLinharesBombas />,
  },
  {
    path: "/recuperacao-motores-hidraulicos-linhares",
    element: <LocalLinharesMotores />,
  },
  {
    path: "/recuperacao-redutores-industriais-linhares",
    element: <LocalLinharesRedutores />,
  },
  {
    path: "/hidraulica-industrial-linhares",
    element: <LocalLinharesHidraulica />,
  },
  {
    path: "/mecanica-industrial-linhares",
    element: <LocalLinharesMecanica />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;